export class CountdownElement extends HTMLElement {
  private timer: number | null = null
  private endTime: number = 0
  private daysElement: HTMLElement | null = null
  private hoursElement: HTMLElement | null = null
  private minutesElement: HTMLElement | null = null
  private secondsElement: HTMLElement | null = null

  constructor() {
    super()
    this.updateCountdown = this.updateCountdown.bind(this)
  }

  connectedCallback() {
    this.daysElement = this.querySelector('[data-countdown-days]')
    this.hoursElement = this.querySelector('[data-countdown-hours]')
    this.minutesElement = this.querySelector('[data-countdown-minutes]')
    this.secondsElement = this.querySelector('[data-countdown-seconds]')

    const endDate = this.getAttribute('data-end-date')
    if (endDate) {
      this.endTime = new Date(endDate).getTime()
      const now = new Date().getTime()
      const timeDiff = this.endTime - now

      if (timeDiff > 0) {
        this.updateCountdown()
        this.timer = window.setInterval(this.updateCountdown, 1000)
      } else {
        this.setAttribute('data-ui', 'hidden')
      }
    }
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  updateCountdown() {
    const now = new Date().getTime()
    const timeDiff = this.endTime - now

    if (timeDiff < 1) {
      this.setAttribute('data-ui', 'hidden')
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      return
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)

    if (this.daysElement) {
      this.daysElement.textContent = days.toString().padStart(2, '0')
    }
    if (this.hoursElement) {
      this.hoursElement.textContent = hours.toString().padStart(2, '0')
    }
    if (this.minutesElement) {
      this.minutesElement.textContent = minutes.toString().padStart(2, '0')
    }
    if (this.secondsElement) {
      this.secondsElement.textContent = seconds.toString().padStart(2, '0')
    }
    this.setAttribute('data-ui', 'visible')
  }
}
